import {
  AccessibilityGlyph,
  DashboardGlyph,
  HomeGlyph,
  PeopleGlyph,
  SmartToyGlyph,
  SyncGradientGlyph,
} from 'Assets/Svg/Icons'

import { SectorsWeEngineerItem, SectorsWeEngineerItemId } from './types'

// The verticals actually delivered into, matching the homepage audience block
// and the external profiles. Real estate and insurance stay off this list on
// purpose — consultancy and research engagements, not shipped products.
export const SECTORS_WE_ENGINEER_ITEMS: SectorsWeEngineerItem[] = [
  {
    id: SectorsWeEngineerItemId.Construction,
    title: 'Construction and trades',
    description:
      'Project cost control, dockets, variations\nand field data capture.',
    icon: HomeGlyph,
    projectLinks: [{ id: 'lbr-mgr', name: 'LbR MgR', slug: 'lbr-mgr' }],
  },
  {
    id: SectorsWeEngineerItemId.Automotive,
    title: 'Automotive dealer groups',
    description:
      'AI on the sales floor — customer context,\nfollow-up and pipeline visibility.',
    icon: SmartToyGlyph,
    projectLinks: [],
  },
  {
    id: SectorsWeEngineerItemId.Healthcare,
    title: 'Healthcare and multi-site operators',
    description:
      'Intake, records, scheduling and the admin\nsitting between systems.',
    icon: AccessibilityGlyph,
    projectLinks: [
      { id: 'dmi', name: 'DMI', slug: 'dmi' },
      { id: 'ohanalink', name: 'OhanaLink', slug: 'ohanalink' },
    ],
  },
  {
    id: SectorsWeEngineerItemId.Workforce,
    title: 'Workforce-heavy operations',
    description:
      'Scheduling, shift tracking, availability\nand location-aware clock-ins.',
    icon: PeopleGlyph,
    projectLinks: [
      { id: 'workaxle', name: 'WorkAxle', slug: 'workaxle' },
      { id: 'guided', name: 'Guided', slug: 'guided' },
    ],
  },
  {
    id: SectorsWeEngineerItemId.SupplyChain,
    title: 'Supply chain and logistics',
    description:
      'Workflow automation, data assurance\nand end-to-end visibility.',
    icon: SyncGradientGlyph,
    projectLinks: [
      { id: 'morpheus', name: 'Morpheus.Network', slug: 'morpheus' },
    ],
  },
  {
    id: SectorsWeEngineerItemId.Saas,
    title: 'SaaS and vertical software builders',
    description:
      'Platforms that have to hold up well past\nthe MVP that got them here.',
    icon: DashboardGlyph,
    projectLinks: [
      { id: 'futurwise', name: 'Futurwise', slug: 'futurwise' },
      { id: 'networkos', name: 'NetworkOS', slug: 'networkos' },
    ],
  },
]
